import URI from 'urijs'
import Backbone from '@polleverywhere/backbone'
import Comparison from './comparison'

/**
 * Collection of polls that are available to generate comparison data against.
 * This is currently only used by MCP activities.
 */
export default class ComparisonCollection extends Backbone.Collection {
  get model () {
    return Comparison
  }

  get activity () {
    return this.options.activity
  }

  /**
   * Initializer
   * @param {Array} models List of serialized objects or Archive models.
   * @param {Object} options Configurable options
   * @param {Backbone.Model} options.activity Activity model
   */
  initialize (models = [], options = {}) {
    this.options = Object.assign({}, options)
  }

  url () {
    if (!this.activity) {
      throw new Error('Activity must be provided')
    }

    return URI(this.activity.instance.url())
      .segment('comparisons')
      .toString()
  }
}
